import React from 'react';
import { Box, Container, Typography } from '@mui/material';
import policiesContent from '../content/policies.json';
import SectionCard from './SectionCard';

const Policies = () => {
    const { title, intro, sections } = policiesContent;

    const nestedPanelSx = {
        p: 2.5,
        borderRadius: 3,
        backgroundColor: '#f7deed',
        minWidth: 0,
        boxSizing: 'border-box',
        width: '100%'
    };

    const renderSectionContent = (section) => (
        <>
            <Typography
                className="heading-font"
                variant="h5"
                sx={{ color: '#00476e', fontWeight: 700, mb: 2 }}
            >
                {section.title}
            </Typography>

            {section.paragraphs.map((paragraph, index) => (
                <Typography
                    key={index}
                    variant="body1"
                    sx={{
                        color: 'rgba(0, 71, 110, 0.78)',
                        lineHeight: 1.8,
                        mb: index === section.paragraphs.length - 1 ? 0 : 2
                    }}
                >
                    {paragraph}
                </Typography>
            ))}
        </>
    );

    return (
        <Container
            maxWidth={false}
            sx={{
                py: { xs: 4, md: 7 },
                width: 'min(92vw, 1600px)',
                mx: 'auto'
            }}
        >
            <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <SectionCard>
                    <Typography
                        className="heading-font"
                        variant="h2"
                        sx={{
                            color: '#00476e',
                            fontWeight: 700,
                            mb: 2,
                            fontSize: { md: '2.7rem' }
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            color: 'rgba(0, 71, 110, 0.82)',
                            lineHeight: 1.8,
                            maxWidth: 1100,
                            mb: 4
                        }}
                    >
                        {intro}
                    </Typography>

                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 3
                        }}
                    >
                        {sections.map((section) => (
                            <Box key={section.title} sx={nestedPanelSx}>
                                {renderSectionContent(section)}
                            </Box>
                        ))}
                    </Box>
                </SectionCard>
            </Box>

            <Box sx={{ display: { xs: 'block', md: 'none' } }}>
                <SectionCard sx={{ mb: 4 }}>
                    <Typography
                        className="heading-font"
                        variant="h2"
                        sx={{
                            color: '#00476e',
                            fontWeight: 700,
                            mb: 2,
                            fontSize: '2rem'
                        }}
                    >
                        {title}
                    </Typography>

                    <Typography
                        variant="body1"
                        sx={{
                            color: 'rgba(0, 71, 110, 0.82)',
                            lineHeight: 1.8
                        }}
                    >
                        {intro}
                    </Typography>
                </SectionCard>

                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        gap: 3
                    }}
                >
                    {sections.map((section) => (
                        <SectionCard key={section.title}>
                            {renderSectionContent(section)}
                        </SectionCard>
                    ))}
                </Box>
            </Box>
        </Container>
    );
};

export default Policies;